import * as React from "react";
const SvgFiBrandsXing = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M3.798 4.745c-.217 0-.393.077-.484.22-.095.148-.102.321 0 .514l2.445 4.06a.03.03 0 0 1 0 .024l-3.82 6.481c-.1.191-.095.39 0 .538a.52.52 0 0 0 .458.245h3.618c.54 0 .783-.365.967-.685L10.88 9.54 8.408 5.38c-.179-.306-.465-.635-1.018-.635zM18.944 0c-.539 0-.772.326-.966.659L9.955 14.317l5.123 9.023c.18.308.455.66 1.008.66h3.602c.216 0 .386-.079.478-.221.096-.148.093-.343-.008-.535l-5.083-8.915a.02.02 0 0 1 0-.023L23.058.755c.1-.191.102-.386.008-.534-.092-.142-.263-.221-.48-.221z"
    />
  </svg>
);
export default SvgFiBrandsXing;
